import React, { useState, useEffect } from 'react';

import { getAllPress, urlFor } from '../../lib/sanity';

import HeroBanner from "../../assets/press_images/HeroBanner.jpg";

function Press() {
  const [showAllArticles, setShowAllArticles] = useState(false);
  const [pressArticles, setPressArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const INITIAL_ARTICLE_COUNT = 6;

  // fetch press articles from Sanity
  useEffect(() => {
    getAllPress()
      .then((data) => {
        setPressArticles(data || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching press articles:', error);
        setLoading(false);
      });
  }, []);

  const videos = [
  {
    id: 1,
    platform: 'youtube',
    title: 'Manoottangwai',
    src: 'https://www.youtube.com/embed/uRmTWEqPNiE?si=tWwGuKj3pbOcA2Kp',
  },
  {
    id: 2,
    platform: 'facebook',
    title: 'BOT Learning Center',
    src: 'https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2FBOTLearningCenter%2Fvideos%2F648038058114208%2F&show_text=false&t=17',
  },
  {
    id: 3,
    platform: 'youtube',
    title: 'The People Show',
    src: 'https://www.youtube.com/embed/iFeqWK__YBw?start=23',
  },
];



  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-orange-50">
      {/* Hero Section */}
      <section className="relative h-[70vh] sm:h-[80vh] flex items-center justify-center">
        {/* Background image */}
        <img
          src={HeroBanner}
          alt="Our Vision"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto text-center px-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
            Press & Media
          </h1>

          <p className="text-lg sm:text-xl text-gray-100 leading-relaxed">
            Explore media coverage, awards, and stories highlighting the impact of WealthyCats.
          </p>
        </div>
      </section>

      {/* Press Coverage Section */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              In the <span className="text-[#F4900C]">News</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Recent media coverage and press mentions
            </p>
          </div>

          {loading ? (
            <div className="text-center py-12">
              <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#F4900C] mx-auto mb-4"></div>
              <p className="text-gray-600">Loading articles...</p>
            </div>
          ) : pressArticles.length === 0 ? (
            <p className="text-center text-gray-600 py-12">
              No press articles yet. Check back soon.
            </p>
          ) : (
          <>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {(showAllArticles ? pressArticles : pressArticles.slice(0, INITIAL_ARTICLE_COUNT)).map((article) => (
              <a
                key={article._id}
                href={article.link}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-gradient-to-br from-yellow-50 to-orange-50 rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="p-6">
                  {/* Outlet Logo */}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow">
                      {article.logo && (
                        <img
                          src={urlFor(article.logo).width(80).auto('format').url()}
                          alt={article.outlet}
                          className="w-10 h-10 object-contain"
                        />
                      )}
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900">{article.outlet}</p>
                      <p className="text-sm text-gray-600">{article.date}</p>
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#F4900C] transition-colors">
                    {article.title}
                  </h3>

                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {article.excerpt}
                  </p>

                  <div className="flex items-center text-[#F4900C] font-semibold group-hover:translate-x-2 transition-transform">
                    Read Article
                    <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {pressArticles.length > INITIAL_ARTICLE_COUNT && (
            <div className="flex justify-center mt-10">
              <button
                onClick={() => setShowAllArticles(!showAllArticles)}
                className="inline-flex items-center gap-2 px-8 py-3 bg-[#F4900C] text-white font-semibold rounded-full shadow-lg hover:bg-[#e0820a] hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5"
              >
                {showAllArticles ? 'Show Less' : `Show More (${pressArticles.length - INITIAL_ARTICLE_COUNT})`}
                <svg
                  className={`w-5 h-5 transition-transform duration-300 ${showAllArticles ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
            </div>
          )}
          </>
          )}
        </div>
      </section>

      {/* Video Section */}
    <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
    <div className="container-custom">
        <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Featured <span className="text-[#F4900C]">Videos</span>
        </h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Watch highlights and media coverage
        </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
        {videos.map((video) => (
            <div
            key={video.id}
            className="bg-white rounded-xl shadow-lg overflow-hidden"
            >
            {/* Responsive Video Wrapper */}
            <div className="relative w-full pt-[56.25%]">
                <iframe
                src={video.src}
                title={video.title}
                className="absolute top-0 left-0 w-full h-full"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                allowFullScreen
                scrolling="no"
                />
            </div>

            {/* Video Caption */}
            <div className="p-4">
                <p className="font-semibold text-gray-900">
                {video.title}
                </p>
                <p className="text-sm text-gray-500 capitalize">
                {video.platform}
                </p>
            </div>
            </div>
        ))}
        </div>
    </div>
    </section>

    </div>
  );
}

export default Press;